import secureLocalStorage from "react-secure-storage";
import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";

export default class RiskProximityDateCell extends GridCell {
    constructor(props) {
        super(props);
        this.state = {
            defaultValue: new Date(),
        };
      }
      componentDidMount = () => {
    
        try {
          let element = document.getElementsByClassName("k-dateinput")[0];
          if (element) {
            element.addEventListener("keydown", (e) => {
              e.stopPropagation();
              e.preventDefault();
            });
          }
        } catch (err) {
          console.error(err);
        }
      };

      // Direct method to clear the date using the same structure as handleChange
  handleClear = () => {
    console.log("Clear button clicked");
    
    // Create an event object that mimics what the DatePicker would send
    const kendoEvent = {
      value: null,
      target: { value: null },
      syntheticEvent: {
        target: { value: null },
        preventDefault: () => {},
        stopPropagation: () => {}
      }
    };
    
    // Call handleChange with our custom event
    this.handleChange(kendoEvent);
  };

  handleChange(e) {
    this.props.handleCellAddValue(e.target.value);
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        proximityDate: e.target.value,
      };
      this.props.updateDropdownValue(updateData);
    }
  }
  handleEditCell = () => {
    if (this.props.dataItem.riskRegisterId) {
    this.props.onEditCell(this.props.dataItem, this.props.field);
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];

       
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
            <td className="date-picker-cell">
        <div style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          width: "100%"
        }}>
          <DatePicker
            format="dd-MMM-yyyy"
            value={dataValue}
            onChange={this.handleChange.bind(this)}
            defaultShow={true}
            style={{
              width: "100%",
              paddingRight: "24px" // Make room for the clear button
            }}
            popupSettings={{
              anchorAlign: { horizontal: "right", vertical: "bottom" },
              popupAlign: { horizontal: "right", vertical: "top" },
              appendTo: document.body, // Append the popup to the body
            }}
          />
          {dataValue && (
            <button
              type="button"
              onClick={this.handleClear}
              style={{
                cursor: "pointer",
                position: "absolute",
                right: "28px", // Position it just before the calendar icon
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 10,
                background: "transparent",
                border: "none",
                color: "#777",
                fontWeight: "bold",
                fontSize: "14px",
                width: "20px",
                height: "20px",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%"
              }}
              title="Clear date"
            >
              ×
            </button>
          )}
        </div>
      </td>
      
            );
    } else {
      if(loginUserId===ownerId){
        return (
        <td  onClick={this.handleEditCell}>
        {/* <p>{dataValue}</p> */}
        {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
      </td>
        )
      }else{
      return this.props.dataItem.role == "Standard User" ||
      this.props.dataItem.role == "View Only" ? (
        <td >
          {/* <p>{dataValue}</p> */}
          {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
        </td>
      ) : (
        <td  onClick={this.handleEditCell}>
          {/* <p>{dataValue}</p> */}
          {dataValue?moment(dataValue).format('DD-MMM-YYYY'):''}
        </td>
      );
      }
    }
  }
}
